type Props = {
  /** 大タイトル（拠点名 / 建築タイプ名 / (あれば)部屋番号）。`buildRoomTitle` で組んだ文字列 */
  bigTitle: string;
  /** 小タイトル（ルームタイプ displayName）。未設定なら出さない */
  subtitle: string | null;
};

/**
 * タイトルエリア。
 *
 * - 大タイトル: 拠点名 / 建築タイプ名 / (あれば)部屋番号
 * - 小タイトル: ルームタイプ displayName
 *
 * Figma の Headline1 (28px) / Headline2Mobile (20px) を踏襲し、font-dx を当てる。
 */
export function TitleArea({ bigTitle, subtitle }: Props) {
  return (
    <div className="flex flex-col gap-[4px] px-[16px] pt-[24px] pb-[16px]">
      <h1 className="font-dx text-dx-text-default text-[28px] leading-[40px] font-medium tracking-[-0.56px]">
        {bigTitle}
      </h1>
      {subtitle && (
        <h2 className="font-dx text-dx-text-default text-[20px] leading-[28px] font-medium">
          {subtitle}
        </h2>
      )}
    </div>
  );
}

/** ロード中の placeholder。実体と同じ padding / 2 行構造で高さを揃える */
export function TitleAreaSkeleton() {
  return (
    <div className="flex flex-col gap-[6px] px-[16px] pt-[24px] pb-[16px]">
      <div className="bg-dx-surface-subtle h-[40px] w-[60%] animate-pulse rounded-sm" />
      <div className="bg-dx-surface-subtle h-[24px] w-[40%] animate-pulse rounded-sm" />
    </div>
  );
}
